// extracted by mini-css-extract-plugin
export default {"tabContainer":"popupRecommendationList_tabContainer__W09gL","tabs":"popupRecommendationList_tabs__HvVA4","tabItem":"popupRecommendationList_tabItem__kxjx-"};